"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sigma.js WebGL Renderer Edge Arrow Program
 * ===========================================
 *
 * Compound program rendering edges as an arrow from the source to the target.
 */
var program_1 = require("./program");
var arrow_1 = __importDefault(require("./arrow"));
var edge_clamped_1 = __importDefault(require("./edge.clamped"));
var program = program_1.createCompoundProgram([edge_clamped_1.default, arrow_1.default]);
exports.default = program;
